export enum ConfirmationType {
  Yes = 'Yes',
  No = 'No',
}
